import React from "react";
import { NavLink } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { firmAdminLinks, systemAdminLinks } from "./navigation";
export default function AdminSidebar({ account }) {
  const links =
    Number(account?.firmId) === 1 ? systemAdminLinks : firmAdminLinks;
  return (
    <aside className="piers-admin-sidebar">
      <nav aria-label="Administration">
        <h2>Administration</h2>
        {links.map(([to, icon, label]) => (
          <NavLink key={to} to={to}>
            <FeatherIcon icon={icon} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
